import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import TopBar from "./TopBar";
import SideDrawer from "./SideDrawer";
import { DRAWER_OPEN_WIDTH, DRAWER_CLOSE_WIDTH } from "./constants";

const Header = () => {
  const [open, setOpen] = useState(true);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width:899.95px)");

  const setCssSidebarVar = (isOpen) => {
    const w = isOpen ? `${DRAWER_OPEN_WIDTH}px` : `${DRAWER_CLOSE_WIDTH}px`;
    document.documentElement.style.setProperty("--sidebar-width", w);
  };

  useEffect(() => {
    setCssSidebarVar(open);
    return () => { };
  }, [open]);

  useEffect(() => {
    setMobileDrawerOpen(false);
  }, [location.pathname, isMobile]);

  const handleToggle = () => {
    setOpen((s) => {
      const next = !s;
      setCssSidebarVar(next);
      return next;
    });
  };

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <>
      <TopBar
        open={open}
        handleToggle={handleToggle}
        isMobile={isMobile}
        onMobileMenuClick={() => setMobileDrawerOpen((current) => !current)}
      />
      <SideDrawer
        open={open}
        mobileOpen={mobileDrawerOpen}
        isMobile={isMobile}
        onClose={() => setMobileDrawerOpen(false)}
        navigate={navigate}
        location={location}
        isActive={isActive}
      />
    </>
  );
};

export default Header;